import { render, staticRenderFns } from "./plan-row.vue?vue&type=template&id=06cf54dd&"
import script from "./plan-row.vue?vue&type=script&lang=ts&"
export * from "./plan-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports